import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { savePriceMemoMaintenanceEndpoint } from '../../../common/endpoints';

export const savePriceMemoMaintenanceData = createApi(savePriceMemoMaintenanceEndpoint, 'PUT');

const SavePriceMemo = createSlice({
  name: 'SavePriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(savePriceMemoMaintenanceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePriceMemoMaintenanceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(savePriceMemoMaintenanceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SavePriceMemo.reducer;